import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { useFetch } from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'
import { isRefundMethodVisible } from '@/returns/pages/TransactionRMAPage/TransactionRMAPageContent/helpers'
import returnsServices from '@/returns/services/services'
import routes from '@/Router/routes.constants'

import { getCompleteRmaPayload } from './helpers'

const useComplete = ({ setToastInfo }) => {
  const { rmaInfo } = useContext(RMAContext)
  const { loading: completingRma, fetchData: completeRma } = useFetch(returnsServices.completeRma, {
    doInitialRequest: false,
  })
  const navigation = useNavigate()

  const handleCompleteRma = async () => {
    try {
      await completeRma({
        orderId: rmaInfo.orderInfo.id,
        returnId: rmaInfo.orderInfo.returnId,
        payload: getCompleteRmaPayload(rmaInfo),
      })

      navigation(routes.transactionsPage)
    } catch (err) {
      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  const isCompleteRmaValid = () => {
    const hasRefundTypeIfRequired = isRefundMethodVisible(rmaInfo) ? Boolean(rmaInfo?.orderInfo?.refundType) : true

    return Boolean(rmaInfo?.items?.length > 0 && rmaInfo?.orderInfo?.deliveryMethod && hasRefundTypeIfRequired)
  }
  return { completingRma, handleCompleteRma, isCompleteRmaValid }
}

export default useComplete
